
import React, { useState, useEffect } from 'react';

export function useCounts(period = 'day', rawCounts) {

    const [groupedCounts, setGroupedCounts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {


        const toHourString = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hour = date.getHours().toString().padStart(2, '0');
            return `${year}-${month}-${day}T${hour}`;
        };

        const toDayString = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const toWeekString = (date) => {
            const year = date.getFullYear();
            const firstJan = new Date(date.getFullYear(), 0, 1);
            const days = Math.floor((date - firstJan) / (24 * 60 * 60 * 1000));
            const week = Math.ceil((days + firstJan.getDay() + 1) / 7);
            return `${year}-W${week.toString().padStart(2, '0')}`;
        };

        const toTwoWeekString = (date) => {
            const year = date.getFullYear();
            const firstJan = new Date(date.getFullYear(), 0, 1);
            const days = Math.floor((date - firstJan) / (24 * 60 * 60 * 1000));
            const biweek = Math.ceil((days + firstJan.getDay() + 1) / 14);
            return `${year}-B${biweek.toString().padStart(2, '0')}`;
        };

        const toMonthString = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            return `${year}-${month}`;
        };

        const countsByEmojiAndPeriod = (counts, period = 'day') => {
            const getPeriodKey = {
                hour: toHourString,
                day: toDayString,
                week: toWeekString,
                biweek: toTwoWeekString,
                month: toMonthString,
            }[period];

            const grouped = counts.reduce((acc, count) => {
                const date = new Date(count.date);
                const periodKey = getPeriodKey(date);
                if (!acc[periodKey]) acc[periodKey] = {};
                if (!acc[periodKey][count.emoji]) acc[periodKey][count.emoji] = 0;
                acc[periodKey][count.emoji]++;
                return acc;
            }, {})
            return Object.entries(grouped)
                .sort(([a], [b]) => new Date(b) - new Date(a))
        };

        const fetchCounts = async (period) => {
            setLoading(true);
            if (rawCounts && rawCounts.length > 0) {
                setGroupedCounts(countsByEmojiAndPeriod(rawCounts, period));
                setLoading(false);
                return;
            }
            try {
                const container = window.CloudKit.getDefaultContainer();
                const database = container.privateCloudDatabase;
                const query = { recordType: 'CD_TapCount', sortBy: [{ fieldName: 'CD_date', ascending: false }] };
                let fetchedCounts = [];
                let continuationMarker = null;

                do {
                    const response = await database.performQuery(query, { continuationMarker });
                    
                    if (response.records) {
                        console.log('Response:', response.records);
                        const pageCounts = response.records.map(record => ({
                            id: record.recordName,
                            emoji: record.fields.CD_shortDisplay.value,
                            date: record.fields.CD_date.value
                        }));
                        fetchedCounts = fetchedCounts.concat(pageCounts);
                    }
                    
                    continuationMarker = response.continuationMarker;
                } while (continuationMarker);
                console.log('Fetched counts:', fetchedCounts);
                setGroupedCounts(countsByEmojiAndPeriod(fetchedCounts, period));
                setLoading(false);
            } catch (err) {
                console.error('Error fetching taps:', err);
            }
        }
        fetchCounts(period);
    }, [period]);

    return { loading, groupedCounts };
}